import type React from 'react';
import AkomiMediaCard from './AkomiMediaCard/AkomiMediaCard';
import AkomiCollectionMediaCard from './Collection/AkomiCollectionMediaCard';
import type { CollectionItem, MediaCardRouterProps, MediaItem } from './types';

export const AkomiMediaCardRouter: React.FC<MediaCardRouterProps> = ({ item, index }) => {
  const isCollection = item.__typename?.includes('Collection');

  if (isCollection) {
    return (
      <AkomiCollectionMediaCard
        mediaCardMediaPageIndex={index}
        collection={item as CollectionItem}
        akomiMediaCardIndex={index}
      />
    );
  }

  return <AkomiMediaCard mediaCardMediaPageIndex={index} item={item as MediaItem} akomiMediaCardIndex={index} />;
};

export default AkomiMediaCardRouter;
